import React,{Component} from 'react';
import {connect} from 'react-redux'
import {mediaPath } from "../../config";

class Notification extends Component {
	render(){
		return (
      <div id="notification-message" className={this.props.notification?'':'hide'}>
        <div className="alert alert-danger">
          <a className="close" aria-label="close" title="close"><img src={mediaPath+"close-white.png"} alt="Close"/></a>
          <span>{this.props.notification}</span>
        </div>
      </div>
		)
	}
}
function mapStateToProps(state) {
	return {notification:state.uiState.notification};
}
export default connect(mapStateToProps, null)(Notification);